import request from '@/utils/request'

let ProductProfitsApi = {
  getGradeList(data, errorback) {
    return request._get('/shop/data.user/grade', data, errorback);
  },
  /*获取列表*/
  getList(data, errorback) {
    return request._get('/shop/productprofits.profits/index', data, errorback);
  },
  /*查看详情*/
  getDetail(data, errorback) {
    return request._post('/shop/productprofits.profits/detail', data, errorback);
  },

}
export default ProductProfitsApi;



// WEBPACK FOOTER //
// ./src/api/productprofits.js